export default __webpack_public_path__ + "static/media/Bronze_Book_C3 (1).23e4312f.png";